export default __webpack_public_path__ + "static/media/like-on.cfe63298.svg";